// removed by extract-text-webpack-plugin
module.exports = {"headlineRow":"geographic-module__headlineRow___NDi36","row":"geographic-module__row___duz8N","markdown":"geographic-module__markdown___1FAoa","desktopSidebar":"geographic-module__desktopSidebar___zaxZo","imageContainer":"geographic-module__imageContainer___1eHHk","img":"geographic-module__img___RW1IJ","bottomImg":"geographic-module__bottomImg___23lKF","chapterLink":"geographic-module__chapterLink___bpXwD"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/geographic/geographic.module.scss
// module id = 274
// module chunks = 0